import { render, staticRenderFns } from "./DayTripNav.v2.vue?vue&type=template&id=63ae4de8&"
import script from "./DayTripNav.v2.vue?vue&type=script&lang=js&"
export * from "./DayTripNav.v2.vue?vue&type=script&lang=js&"
import style0 from "./DayTripNav.v2.vue?vue&type=style&index=0&id=63ae4de8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports